import { Construction, Mail, Phone } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useSiteSettings } from "@/hooks/useSiteSettings";
import { useAuth } from "@/hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const Maintenance = () => {
  const { settings } = useSiteSettings();
  const { profile, loading } = useAuth();
  const navigate = useNavigate();

  // Redirect admins to admin panel (using user_roles for security)
  useEffect(() => {
    if (!loading && profile?.role) {
      const adminRoles = ['admin', 'super_admin', 'hr'];
      if (adminRoles.includes(profile.role)) {
        navigate('/admin', { replace: true });
      }
    }
  }, [profile, loading, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 via-background to-primary/10 flex items-center justify-center p-4">
      <Card className="max-w-2xl w-full shadow-2xl">
        <CardHeader className="text-center space-y-4 pb-8">
          <div className="mx-auto w-24 h-24 rounded-full bg-primary/10 flex items-center justify-center">
            <Construction className="h-12 w-12 text-primary animate-pulse" />
          </div>
          <CardTitle className="text-4xl font-bold">
            Maintenance en cours
          </CardTitle>
          <CardDescription className="text-lg">
            Notre site est actuellement en maintenance pour vous offrir une meilleure expérience
          </CardDescription>
        </CardHeader>
        
        <CardContent className="space-y-6">
          <div className="text-center space-y-4">
            <p className="text-muted-foreground">
              Nous effectuons actuellement des améliorations importantes sur notre plateforme.
              Nous serons de retour très bientôt avec de nouvelles fonctionnalités et une expérience améliorée.
            </p>
            
            <div className="bg-muted/50 rounded-lg p-6 space-y-3">
              <p className="font-medium text-foreground">
                Nous nous excusons pour la gêne occasionnée.
              </p>
              <p className="text-sm text-muted-foreground">
                Si vous avez besoin d'assistance urgente, n'hésitez pas à nous contacter :
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center pt-2">
                {settings.contact_email && (
                  <a
                    href={`mailto:${settings.contact_email}`}
                    className="inline-flex items-center justify-center gap-2 text-primary hover:text-primary/80 transition-colors"
                  >
                    <Mail className="h-4 w-4" />
                    <span className="text-sm font-medium">{settings.contact_email}</span>
                  </a>
                )}
                
                {settings.support_phone && (
                  <a
                    href={`tel:${settings.support_phone}`}
                    className="inline-flex items-center justify-center gap-2 text-primary hover:text-primary/80 transition-colors"
                  >
                    <Phone className="h-4 w-4" />
                    <span className="text-sm font-medium">{settings.support_phone}</span>
                  </a>
                )}
              </div>
            </div>
          </div>
          
          <div className="text-center pt-4">
            <p className="text-sm text-muted-foreground">
              Merci pour votre patience et votre compréhension
            </p>
            <p className="text-lg font-semibold text-primary mt-2">
              {settings.site_name || 'Nazandoo'}
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Maintenance;
